import styled from 'styled-components';

const StyledContainer = styled.div`
  position: relative;
  padding-right: 46px;
  display: block;
`;

const StyledSelectContainer = styled.div`
  margin-right: 16px;
  min-width: 210px;
  button {
    width: 100%;
  }
`;

const StyledSearchContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  z-index: 1;
  justify-content: flex-end;
  width: ${props => (props.open ? '100%' : 'auto')};
`;

export { StyledSelectContainer, StyledContainer, StyledSearchContainer };
